import { render, staticRenderFns } from "./AnimationPaste.vue?vue&type=template&id=463db5bc&scoped=true&"
import script from "./AnimationPaste.vue?vue&type=script&lang=js&"
export * from "./AnimationPaste.vue?vue&type=script&lang=js&"
import style0 from "./AnimationPaste.vue?vue&type=style&index=0&id=463db5bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463db5bc",
  null
  
)

export default component.exports